export default "__VITE_ASSET__c8184d60__"